(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tagName = 'featured-collection-slideshow';
    if (!window.customElements || customElements.get(tagName)) return;

    class FeaturedCollectionSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        // Editor-rendered fragments already contain their children. Initialize
        // immediately so a following block-selection event is not missed.
        if (this.querySelector('.fcsl-status')) {
          this.initialize();
        } else {
          this.startFrame = requestAnimationFrame(() => {
            if (this.isConnected && !this.controller) this.initialize();
          });
        }
      }

      initialize() {
        this.controller = new AbortController();
        const listen = (target, type, handler, options = {}) => {
          target.addEventListener(type, handler, { ...options, signal: this.controller.signal });
        };
        this.slides = Array.from(this.querySelectorAll('[data-fcsl-slide]'));
        this.nav = this.querySelector('.fcsl-navigation');
        this.counter = this.querySelector('.fcsl-counter');
        this.status = this.querySelector('.fcsl-status');
        // Also remove an old control when only this JavaScript block is replaced.
        const oldPlaybackButton = this.querySelector('[data-fcsl-action="playback"]');
        if (oldPlaybackButton) oldPlaybackButton.remove();
        // Keep the visitor's choice if this same element is detached/reconnected.
        this.userStopped = Boolean(this.userStopped || this.contains(document.activeElement));
        this.index = 0;
        this.hovered = matchMedia('(any-hover: hover)').matches && this.matches(':hover');
        this.editor = Boolean(window.Shopify && window.Shopify.designMode);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoAllowed = this.dataset.autoplay === 'true';
        this.delay = (Number(this.dataset.delay) || 6) * 1000;
        this.nav.hidden = this.slides.length < 2;
        if (!this.slides.length) return;

        this.querySelectorAll('.fcsl-product-arrow').forEach(button => { button.hidden = false; });
        this.classList.add('fcsl-ready');
        this.show(0, false);

        listen(this, 'click', event => {
          const button = event.target.closest('[data-fcsl-action]');
          if (!button || !this.contains(button) || button.disabled) return;
          const action = button.dataset.fcslAction;
          this.stopForBrowsing();
          if (action === 'collection-prev') this.show(this.index - 1);
          if (action === 'collection-next') this.show(this.index + 1);
          if (action === 'products-prev' || action === 'products-next') {
            const track = button.closest('[data-fcsl-slide]').querySelector('.fcsl-products');
            if (!track) return;
            const direction = action === 'products-next' ? 1 : -1;
            const style = getComputedStyle(track);
            const rtl = style.direction === 'rtl' ? -1 : 1;
            const distance = track.clientWidth + (parseFloat(style.columnGap) || 0);
            track.scrollBy({ left: distance * direction * rtl, behavior: this.motion.matches ? 'auto' : 'smooth' });
          }
        });
        // Browsing always wins over autoplay. Capture catches events even if a
        // product card stops propagation. Passive handlers leave scrolling intact.
        const stopForBrowsing = () => this.stopForBrowsing();
        ['pointerdown', 'touchstart', 'touchmove', 'wheel'].forEach(type => {
          listen(this, type, stopForBrowsing, { capture: true, passive: true });
        });
        ['click', 'focusin', 'keydown'].forEach(type => {
          listen(this, type, stopForBrowsing, { capture: true });
        });
        listen(this, 'pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; clearTimeout(this.timer); }
        });
        listen(this, 'pointerleave', event => {
          if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); }
        });
        listen(document, 'visibilitychange', () => this.schedule());
        listen(this.motion, 'change', () => this.setPlaying(false));
        listen(this, 'shopify:block:select', event => {
          const blockId = event.detail && event.detail.blockId;
          const index = this.slides.findIndex(slide => slide.dataset.blockId === blockId);
          if (index !== -1) { this.setPlaying(false); this.show(index, false); }
        });
        this.querySelectorAll('.fcsl-products').forEach(track => {
          let previousLeft = track.scrollLeft;
          listen(track, 'scroll', () => {
            const moved = Math.abs(track.scrollLeft - previousLeft) > 0.5;
            previousLeft = track.scrollLeft;
            // Protect scrollbar drags and momentum scrolling, not only clicks.
            if (moved && track.closest('[data-fcsl-slide]') === this.slides[this.index]) {
              this.stopForBrowsing();
            }
            this.updateProductControls();
          }, { passive: true });
        });
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(() => this.updateProductControls());
          this.querySelectorAll('.fcsl-products').forEach(track => this.resizeObserver.observe(track));
        } else {
          listen(window, 'resize', () => this.updateProductControls(), { passive: true });
        }
        this.setPlaying(this.autoAllowed);
      }

      show(index, announce = true) {
        const previous = this.slides[this.index];
        const focusWasInside = previous && previous.contains(document.activeElement);
        this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => {
          const active = position === this.index;
          slide.dataset.active = String(active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        const current = this.slides[this.index];
        this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
        if (announce) this.status.textContent = `Collection ${this.index + 1} of ${this.slides.length}: ${current.dataset.title}`;
        if (focusWasInside && previous !== current) current.querySelector('.fcsl-title').focus({ preventScroll: true });
        this.updateProductControls();
        cancelAnimationFrame(this.imageFrame);
        this.imageFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.updateProductControls();
          // Support the existing theme's lazy-loaded card images when revealed.
          if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
            window.lazySizes.loader.checkElems();
          }
        });
      }

      updateProductControls() {
        const slide = this.slides[this.index];
        const track = slide && slide.querySelector('.fcsl-products');
        if (!track) return;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const position = Math.abs(track.scrollLeft);
        const row = track.closest('.fcsl-product-row');
        row.classList.toggle('fcsl-no-overflow', max <= 2);
        row.querySelector('[data-fcsl-action="products-prev"]').disabled = position <= 2;
        row.querySelector('[data-fcsl-action="products-next"]').disabled = position >= max - 2;
      }

      stopForBrowsing() {
        // No inactivity timeout: someone may still be reading or comparing.
        // Manual collection/product controls continue to work normally.
        this.userStopped = true;
        this.setPlaying(false);
      }

      setPlaying(value) {
        this.playing = Boolean(value && this.autoAllowed && !this.userStopped &&
          !this.editor && !this.motion.matches && this.slides.length > 1);
        this.schedule();
      }

      canAutoplay() {
        return this.playing && !this.userStopped && !this.editor &&
          !this.motion.matches && !this.hovered && !document.hidden &&
          !this.contains(document.activeElement) && this.isConnected &&
          this.slides.length > 1;
      }

      schedule() {
        clearTimeout(this.timer);
        this.timer = null;
        if (!this.canAutoplay()) return;
        // Always start a fresh full interval. Never catch up on missed slides.
        this.timer = setTimeout(() => {
          this.timer = null;
          // Recheck immediately before changing the collection.
          if (!this.canAutoplay()) return;
          this.show(this.index + 1, false);
          this.schedule();
        }, this.delay);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.imageFrame);
        clearTimeout(this.timer);
        if (this.controller) this.controller.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.controller = null;
      }
    }
    customElements.define(tagName, FeaturedCollectionSlideshow);
  })();

  } catch(e) { console.error(e); }
})();
})();
